import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Projects from "./pages/Projects";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Quote from "./pages/Quote";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kurumsal" element={<About />} />
          <Route path="/urunler" element={<Products />} />
          <Route path="/urunler/:slug" element={<ProductDetail />} />
          <Route path="/projeler" element={<Projects />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/teklif-al" element={<Quote />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/kvkk" element={<Legal />} />
          <Route path="/gizlilik" element={<Legal />} />
          <Route path="/cerez" element={<Legal />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            fontFamily: "Poppins, sans-serif",
            border: "1px solid rgba(30,30,30,0.06)",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
